import React, { useState } from 'react';
import './qualification.css';

const experienceItems = [
    {
        title: 'Full Stack Developer',
        organization: 'Callby.ai',
        meta: 'Istanbul, Turkiye | Remote',
        date: 'Aug 2025 - Present',
        points: [
            'Refactored the Python backend into API, service, repository, and Pydantic data-model layers with asynchronous authentication, validation, and consistent error handling.',
            'Improved frontend usability with clearer agent settings, call ID copy actions, repeat-call sorting, Turkish localization, and richer Excel exports.',
            'Built prompts and a RAG pipeline for a municipal service system using PostgreSQL, pgvector, query normalization, synonym expansion, reranking, and relevance thresholds.',
            'Developed structured intake and function-calling workflows for insurance claims, complaints, service ticketing, DTMF input, and SMS OTP verification.',
            'Orchestrated n8n and Activepieces workflows for API integrations, complaint records, knowledge ingestion, transcript processing, daily reports, and call-event persistence.'
        ],
        skills: 'Python, FastAPI, Pydantic, React.js, PostgreSQL, pgvector, Redis, n8n, Activepieces'
    },
    {
        title: 'Full Stack Developer',
        organization: 'Arkenom',
        meta: 'Istanbul, Turkiye | Remote',
        date: 'Dec 2024 - Aug 2025',
        points: [
            'Promoted from intern to full-time developer in Jun 2025.',
            'Built and maintained .NET, C#, SQL, and JavaScript features while resolving production issues.',
            'Improved APIs and database queries, fixed bugs, and supported releases in an agile team.'
        ],
        skills: '.NET, C#, SQL, JavaScript, Git, Docker, Azure DevOps, Jira'
    },
    {
        title: 'Backend Developer Intern',
        organization: 'AKEDAS Elektrik Dagitim A.S.',
        meta: 'Kahramanmaras, Turkiye | On-site',
        date: 'Jul 2024 - Sep 2024',
        points: [
            'Built an inventory, user, and order management application with ASP.NET Core API and Razor Pages.',
            'Developed REST APIs and SQL Server data access using Entity Framework, ADO.NET, and LINQ.'
        ],
        skills: 'ASP.NET Core, Razor Pages, SQL Server, Entity Framework, ADO.NET, LINQ'
    },
    {
        title: 'Full Stack Developer',
        organization: 'Freelance',
        meta: 'Remote',
        date: 'Feb 2022 - Jun 2024',
        points: [
            'Delivered desktop and web applications, Telegram bots, and n8n automations for notifications, customer interactions, and task routing.',
            'Managed requirements, implementation, client communication, delivery, and maintenance.'
        ],
        skills: 'Desktop Apps, Web Applications, Telegram Bots, n8n, Client Delivery'
    }
];

const educationItems = [
    {
        title: "Bachelor's Degree in Software Engineering",
        organization: 'Firat University',
        meta: 'Turkiye',
        date: '2021 - 2025',
        points: [
            'Built a foundation in software engineering, algorithms, data structures, object-oriented design, and full-stack development.'
        ]
    }
];

const TimelineItem = ({ item, index, isLast }) => {
    const content = (
        <div className="qualification__card">
            <h3 className="qualification__title">{item.title}</h3>
            <span className="qualification__subtitle">{item.organization}</span>
            <span className="qualification__meta">{item.meta}</span>
            <div className="qualification__calender">
                <i className="uil uil-calendar-alt"></i> {item.date}
            </div>
            <ul className="qualification__list">
                {item.points.map((point) => (
                    <li key={point}>{point}</li>
                ))}
            </ul>
            {item.skills && <p className="qualification__skills">{item.skills}</p>}
        </div>
    );

    return (
        <div className="qualification__data">
            {index % 2 === 0 ? content : <div></div>}
            <div>
                <span className="qualification__rounder"></span>
                {!isLast && <span className="qualification__line"></span>}
            </div>
            {index % 2 === 0 ? <div></div> : content}
        </div>
    );
};

const CvQualification = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const visibleItems = toggleState === 1 ? experienceItems : educationItems;

    return (
        <section className="qualification section" id="Qualification">
            <h2 className="section__title">Experience</h2>
            <span className="section__subtitle">Professional journey</span>

            <div className="qualification__container container">
                <div className="qualification__tabs">
                    <div className={toggleState === 1 ? "qualification__button qualification-active button--flex" :
                    "qualification__button button--flex"} onClick={() => toggleTab(1)}>
                        <i className="uil uil-briefcase-alt qualification__icon"></i> Experience
                    </div>
                    <div className={toggleState === 2 ? "qualification__button qualification-active button--flex" :
                    "qualification__button button--flex"} onClick={() => toggleTab(2)}>
                        <i className="uil uil-graduation-cap qualification__icon"></i> Education
                    </div>
                </div>
                <div className="qualification__sections">
                    <div className="qualification__content qualification__content-active">
                        {visibleItems.map((item, index) => (
                            <TimelineItem
                                key={`${item.organization}-${item.date}`}
                                item={item}
                                index={index}
                                isLast={index === visibleItems.length - 1}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CvQualification;
